<div class="dialog confirm-dialog">
  <button mat-button mat-dialog-close class="dialog__close" (click)="dialogRef.close()">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon><span>{{ 'admin.close' | translate }}</span>
  </button>
  <div mat-dialog-title>
    <header>{{ 'admin.editExportLimit' | translate | uppercase }}</header>
  </div>
  <div mat-dialog-content class="confirm-container">
    <div class="viewmode">
      <table [formGroup]="exportLimitsFormGroup" aria-hidden="true">
        <thead>
          <tr>
            <th scope="col">{{ 'admin.availability' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.leaseComps' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.saleComps' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.portfoliosaleComp' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.property' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.tim' | translate | uppercase }}</th>
            <th scope="col">{{ 'admin.company' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.contact' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.tenancy' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.brand' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.space' | translate | titlecase }}</th>
            <th scope="col">{{ 'admin.activity' | translate | titlecase }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="number"
                  autocomplete="no-autofill"
                  [placeholder]="'admin.availability' | translate"
                  [formControl]="availability"
                  required
                  />
                  @if (availability.hasError('required')) {
                    <mat-error>
                      {{ 'admin.availability' | translate }} {{ 'admin.isRequired' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="number"
                    autocomplete="no-autofill"
                    [placeholder]="'admin.leaseComps' | translate"
                    [formControl]="lease"
                    required
                    />
                    @if (lease.hasError('required')) {
                      <mat-error>
                        {{ 'admin.leaseComps' | translate }} {{ 'admin.isRequired' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="number"
                      autocomplete="no-autofill"
                      [placeholder]="'admin.saleComps' | translate"
                      [formControl]="sale"
                      required
                      />
                      @if (sale.hasError('required')) {
                        <mat-error>
                          {{ 'admin.saleComps' | translate }} {{ 'admin.isRequired' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="number"
                        autocomplete="no-autofill"
                        [placeholder]="'admin.portfoliosaleComp' | translate"
                        [formControl]="portfoliosale"
                        required
                        />
                        @if (portfoliosale.hasError('required')) {
                          <mat-error>
                            {{ 'admin.portfoliosaleComps' | translate }} {{ 'admin.isRequired' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          type="number"
                          autocomplete="no-autofill"
                          [placeholder]="'admin.property' | translate"
                          [formControl]="property"
                          required
                          />
                          @if (property.hasError('required')) {
                            <mat-error>
                              {{ 'admin.property' | translate }} {{ 'admin.isRequired' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field appearance="outline">
                          <input
                            matInput
                            type="number"
                            autocomplete="no-autofill"
                            [placeholder]="'admin.tim' | translate"
                            [formControl]="tim"
                            required
                            />
                            @if (tim.hasError('required')) {
                              <mat-error>
                                {{ 'admin.tim' | translate }} {{ 'admin.isRequired' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              type="number"
                              autocomplete="no-autofill"
                              [placeholder]="'admin.company' | translate"
                              [formControl]="company"
                              required
                              />
                              @if (company.hasError('required')) {
                                <mat-error>
                                  {{ 'admin.company' | translate }} {{ 'admin.isRequired' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                type="number"
                                autocomplete="no-autofill"
                                [placeholder]="'admin.contact' | translate"
                                [formControl]="contact"
                                required
                                />
                                @if (contact.hasError('required')) {
                                  <mat-error>
                                    {{ 'admin.contact' | translate }} {{ 'admin.isRequired' | translate }}
                                  </mat-error>
                                }
                              </mat-form-field>
                            </td>
                            <td>
                              <mat-form-field appearance="outline">
                                <input
                                  matInput
                                  type="number"
                                  autocomplete="no-autofill"
                                  [placeholder]="'admin.tenancy' | translate"
                                  [formControl]="tenancy"
                                  required
                                  />
                                  @if (tenancy.hasError('required')) {
                                    <mat-error>
                                      {{ 'admin.tenancy' | translate }} {{ 'admin.isRequired' | translate }}
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline">
                                  <input
                                    matInput
                                    type="number"
                                    autocomplete="no-autofill"
                                    [placeholder]="'admin.brand' | translate"
                                    [formControl]="brand"
                                    required
                                    />
                                    @if (brand.hasError('required')) {
                                      <mat-error>
                                        {{ 'admin.brand' | translate }} {{ 'admin.isRequired' | translate }}
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </td>
                                <td>
                                  <mat-form-field appearance="outline">
                                    <input
                                      matInput
                                      type="number"
                                      autocomplete="no-autofill"
                                      [placeholder]="'admin.space' | translate"
                                      [formControl]="space"
                                      required
                                      />
                                      @if (space.hasError('required')) {
                                        <mat-error>
                                          {{ 'admin.space' | translate }} {{ 'admin.isRequired' | translate }}
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </td>
                                  <td>
                                  <mat-form-field appearance="outline">
                                    <input
                                      matInput
                                      type="number"
                                      autocomplete="no-autofill"
                                      [placeholder]="'admin.activity' | translate"
                                      [formControl]="activity"
                                      required
                                      />
                                      @if (activity.hasError('required')) {
                                        <mat-error>
                                          {{ 'admin.activity' | translate }} {{ 'admin.isRequired' | translate }}
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div mat-dialog-actions>
                          <button
                            class="btn-submit"
                            [disabled]="!exportLimitsFormGroup.valid || exportLimitsFormGroup.pristine"
                            (click)="submitChange()"
                            >
                            {{ 'admin.add' | translate }}
                          </button>
                        </div>
                      </div>
